import { render } from "./SolicitudesAsignadas.vue?vue&type=template&id=75455f62&scoped=true"
import script from "./SolicitudesAsignadas.vue?vue&type=script&lang=js"
export * from "./SolicitudesAsignadas.vue?vue&type=script&lang=js"

import "./SolicitudesAsignadas.vue?vue&type=style&index=0&id=75455f62&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75455f62"]])

export default __exports__